export default function InvoiceFilters({ 
  fromDate, 
  setFromDate, 
  toDate, 
  setToDate, 
  onSearch, 
  onClear 
}) {
  // ✅ Función para formatear fecha sin problema de zona horaria
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    // Separar año, mes, día directamente del string
    const [year, month, day] = dateString.split('-');
    
    // Crear fecha en formato legible
    const date = new Date(year, month - 1, day);
    
    return date.toLocaleDateString('es-SV', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="invoice-filters">
      <div className="filters-row">
        <div className="form-group">
          <label className="form-label">📅 Fecha Inicio</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">📅 Fecha Fin</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="filters-actions">
          <button className="btn btn-primary" onClick={onSearch}>
            🔍 Buscar
          </button>
          <button className="btn btn-secondary" onClick={onClear}>
            🔄 Limpiar
          </button>
        </div>
      </div>

      {fromDate && toDate && (
        <div className="alert alert-info">
          <span>
            📊 Buscando facturas desde <strong>{formatDate(fromDate)}</strong> hasta{" "}
            <strong>{formatDate(toDate)}</strong>
          </span>
        </div>
      )}
    </div>
  );
}